// Training routines: type (gym/home/bands) x level (beginner/intermediate/advanced)
export const ROUTINES = [
  {
    id: "gym-beginner",
    type: "gym",
    level: "beginner",
    name: "Full Body Principiante",
    description: "Rutina de cuerpo completo 3 días por semana para construir base.",
    days: [
      {
        name: "Día 1 – Cuerpo completo A",
        exercises: [
          { name: "Sentadilla con barra (técnica)", sets: 3, reps: "10-12", rest: "90s" },
          { name: "Press de banca con barra", sets: 3, reps: "10-12", rest: "90s" },
          { name: "Remo en máquina", sets: 3, reps: "10-12", rest: "90s" },
          { name: "Press militar con mancuernas", sets: 3, reps: "10", rest: "60s" },
          { name: "Plancha frontal", sets: 3, reps: "30s", rest: "45s" },
        ],
      },
      {
        name: "Día 2 – Cuerpo completo B",
        exercises: [
          { name: "Peso muerto rumano", sets: 3, reps: "10", rest: "90s" },
          { name: "Press inclinado mancuernas", sets: 3, reps: "10-12", rest: "90s" },
          { name: "Jalón al pecho", sets: 3, reps: "10-12", rest: "90s" },
          { name: "Curl bíceps con barra", sets: 3, reps: "12", rest: "60s" },
          { name: "Crunch abdominal", sets: 3, reps: "15", rest: "45s" },
        ],
      },
      {
        name: "Día 3 – Cuerpo completo C",
        exercises: [
          { name: "Prensa de piernas", sets: 3, reps: "12", rest: "90s" },
          { name: "Fondos asistidos", sets: 3, reps: "8-10", rest: "90s" },
          { name: "Remo bajo polea", sets: 3, reps: "12", rest: "90s" },
          { name: "Elevaciones laterales", sets: 3, reps: "12", rest: "60s" },
          { name: "Extensión de tríceps", sets: 3, reps: "12", rest: "60s" },
        ],
      },
    ],
  },
  {
    id: "gym-intermediate",
    type: "gym",
    level: "intermediate",
    name: "Push/Pull/Legs Intermedio",
    description: "División PPL para hipertrofia, 6 días por semana.",
    days: [
      {
        name: "Push (Pecho/Hombro/Tríceps)",
        exercises: [
          { name: "Press banca plano", sets: 4, reps: "6-8", rest: "120s" },
          { name: "Press inclinado mancuernas", sets: 3, reps: "8-10", rest: "90s" },
          { name: "Press militar barra", sets: 3, reps: "8", rest: "120s" },
          { name: "Elevaciones laterales", sets: 4, reps: "12-15", rest: "60s" },
          { name: "Fondos paralelas", sets: 3, reps: "10", rest: "90s" },
          { name: "Extensión tríceps polea", sets: 3, reps: "12", rest: "60s" },
        ],
      },
      {
        name: "Pull (Espalda/Bíceps)",
        exercises: [
          { name: "Peso muerto", sets: 4, reps: "5", rest: "180s" },
          { name: "Dominadas", sets: 4, reps: "6-10", rest: "90s" },
          { name: "Remo con barra", sets: 4, reps: "8", rest: "90s" },
          { name: "Jalón al pecho agarre cerrado", sets: 3, reps: "10", rest: "60s" },
          { name: "Curl barra Z", sets: 3, reps: "10", rest: "60s" },
          { name: "Curl martillo", sets: 3, reps: "12", rest: "60s" },
        ],
      },
      {
        name: "Legs (Piernas/Core)",
        exercises: [
          { name: "Sentadilla con barra", sets: 4, reps: "6-8", rest: "150s" },
          { name: "Peso muerto rumano", sets: 4, reps: "8", rest: "120s" },
          { name: "Prensa", sets: 3, reps: "12", rest: "90s" },
          { name: "Curl femoral", sets: 3, reps: "12", rest: "60s" },
          { name: "Gemelos de pie", sets: 4, reps: "15", rest: "45s" },
          { name: "Plancha abdominal", sets: 3, reps: "60s", rest: "45s" },
        ],
      },
    ],
  },
  {
    id: "gym-advanced",
    type: "gym",
    level: "advanced",
    name: "Powerbuilding Avanzado",
    description: "Fuerza + hipertrofia, alta intensidad y volumen.",
    days: [
      {
        name: "Día 1 – Pecho/Espalda fuerza",
        exercises: [
          { name: "Press banca pausa", sets: 5, reps: "5", rest: "180s" },
          { name: "Peso muerto", sets: 5, reps: "3", rest: "240s" },
          { name: "Press inclinado", sets: 4, reps: "8", rest: "120s" },
          { name: "Remo Pendlay", sets: 4, reps: "6", rest: "120s" },
          { name: "Aperturas con polea", sets: 3, reps: "12", rest: "60s" },
        ],
      },
      {
        name: "Día 2 – Piernas fuerza",
        exercises: [
          { name: "Sentadilla con barra", sets: 5, reps: "5", rest: "210s" },
          { name: "Sentadilla frontal", sets: 4, reps: "6", rest: "120s" },
          { name: "Hip thrust", sets: 4, reps: "8", rest: "120s" },
          { name: "Zancadas con mancuernas", sets: 3, reps: "10", rest: "90s" },
          { name: "Gemelos sentado", sets: 5, reps: "15", rest: "45s" },
        ],
      },
      {
        name: "Día 3 – Hombro/Brazo",
        exercises: [
          { name: "Press militar de pie", sets: 5, reps: "5", rest: "150s" },
          { name: "Push press", sets: 4, reps: "6", rest: "120s" },
          { name: "Elevaciones laterales pesadas", sets: 4, reps: "10-12", rest: "60s" },
          { name: "Curl barra estricto", sets: 4, reps: "8", rest: "75s" },
          { name: "Press francés", sets: 4, reps: "10", rest: "60s" },
        ],
      },
      {
        name: "Día 4 – Hipertrofia full",
        exercises: [
          { name: "Press banca cierre", sets: 4, reps: "10", rest: "90s" },
          { name: "Dominadas lastradas", sets: 4, reps: "8", rest: "90s" },
          { name: "Sentadilla búlgara", sets: 4, reps: "10", rest: "75s" },
          { name: "Curl martillo", sets: 4, reps: "12", rest: "60s" },
          { name: "Rueda abdominal", sets: 3, reps: "12", rest: "60s" },
        ],
      },
    ],
  },
  {
    id: "home-beginner",
    type: "home",
    level: "beginner",
    name: "En Casa – Principiante",
    description: "Solo peso corporal, ideal para empezar sin equipo.",
    days: [
      {
        name: "Día 1 – Tren superior",
        exercises: [
          { name: "Flexiones con rodillas apoyadas", sets: 3, reps: "8-12", rest: "60s" },
          { name: "Remo invertido en mesa", sets: 3, reps: "8", rest: "60s" },
          { name: "Fondos en silla (tríceps)", sets: 3, reps: "10", rest: "60s" },
          { name: "Plancha", sets: 3, reps: "30s", rest: "45s" },
        ],
      },
      {
        name: "Día 2 – Tren inferior",
        exercises: [
          { name: "Sentadilla con peso corporal", sets: 3, reps: "15", rest: "60s" },
          { name: "Zancadas alternadas", sets: 3, reps: "12 c/p", rest: "60s" },
          { name: "Puente de glúteos", sets: 3, reps: "15", rest: "60s" },
          { name: "Elevación de talones", sets: 3, reps: "20", rest: "45s" },
        ],
      },
      {
        name: "Día 3 – Full body",
        exercises: [
          { name: "Burpees", sets: 3, reps: "8", rest: "60s" },
          { name: "Mountain climbers", sets: 3, reps: "30s", rest: "45s" },
          { name: "Sentadilla con salto", sets: 3, reps: "10", rest: "60s" },
          { name: "Crunch", sets: 3, reps: "15", rest: "45s" },
        ],
      },
    ],
  },
  {
    id: "home-intermediate",
    type: "home",
    level: "intermediate",
    name: "En Casa – Intermedio",
    description: "Calistenia con progresiones más intensas.",
    days: [
      {
        name: "Día 1 – Push",
        exercises: [
          { name: "Flexiones diamante", sets: 4, reps: "10-12", rest: "75s" },
          { name: "Flexiones declinadas", sets: 4, reps: "10", rest: "75s" },
          { name: "Pike push-up", sets: 3, reps: "8", rest: "75s" },
          { name: "Plancha lateral", sets: 3, reps: "45s c/lado", rest: "45s" },
        ],
      },
      {
        name: "Día 2 – Pull/Legs",
        exercises: [
          { name: "Sentadilla pistol asistida", sets: 4, reps: "6 c/p", rest: "90s" },
          { name: "Zancadas búlgaras (silla)", sets: 4, reps: "10 c/p", rest: "75s" },
          { name: "Puente de glúteos a 1 pierna", sets: 3, reps: "12 c/p", rest: "60s" },
          { name: "Remo invertido bajo", sets: 4, reps: "10", rest: "75s" },
        ],
      },
      {
        name: "Día 3 – HIIT",
        exercises: [
          { name: "Burpees", sets: 5, reps: "12", rest: "45s" },
          { name: "Sprints en sitio", sets: 5, reps: "30s", rest: "30s" },
          { name: "Saltos en cuclillas", sets: 5, reps: "15", rest: "45s" },
          { name: "Crunch bicicleta", sets: 4, reps: "20", rest: "45s" },
        ],
      },
    ],
  },
  {
    id: "bands-beginner",
    type: "bands",
    level: "beginner",
    name: "Con Ligas – Principiante",
    description: "Rutina completa con bandas de resistencia.",
    days: [
      {
        name: "Día 1 – Full body con ligas",
        exercises: [
          { name: "Sentadilla con banda", sets: 3, reps: "15", rest: "60s" },
          { name: "Remo con banda anclada", sets: 3, reps: "12", rest: "60s" },
          { name: "Press de pecho con banda", sets: 3, reps: "12", rest: "60s" },
          { name: "Curl bíceps con banda", sets: 3, reps: "15", rest: "45s" },
          { name: "Press hombro con banda", sets: 3, reps: "12", rest: "60s" },
        ],
      },
      {
        name: "Día 2 – Tren inferior con ligas",
        exercises: [
          { name: "Sentadilla sumo con banda", sets: 4, reps: "15", rest: "60s" },
          { name: "Patada de glúteo con banda", sets: 3, reps: "15 c/p", rest: "45s" },
          { name: "Abducción de cadera", sets: 3, reps: "15 c/p", rest: "45s" },
          { name: "Puente con banda", sets: 4, reps: "15", rest: "60s" },
        ],
      },
      {
        name: "Día 3 – Tren superior con ligas",
        exercises: [
          { name: "Jalón frontal con banda", sets: 4, reps: "12", rest: "60s" },
          { name: "Press inclinado con banda", sets: 3, reps: "12", rest: "60s" },
          { name: "Elevaciones laterales banda", sets: 3, reps: "15", rest: "45s" },
          { name: "Extensión tríceps banda", sets: 3, reps: "15", rest: "45s" },
          { name: "Plancha", sets: 3, reps: "45s", rest: "45s" },
        ],
      },
    ],
  },
];
